import { fetchApi, fetchApiUpload } from "../../app/lib/api"
import { Types } from './types'
import { actionLoading } from '../home/actions'
import { checkErrorCode } from '../auth/actions'
import { LIMIT_PAGE } from '../../lib/common'
import axios from 'axios';

/////////////////////////////User Client////////////////////////////////////////////////
export const getNumberKycDuplicate = async (payload, dispatch) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/kyc/get-dup-kyc`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetListUserClient = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-list-user`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListUserClient(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetHistoryPnlByUserId = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-history-pnl`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit || 10
            }
        }
        await dispatch(actionSaveListHistoryPnl(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetListUserBank = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/list-user-bank`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListUserClient(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}


export const actionGetListUserClientCMS = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-list-user-cms`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListUserClientCMS(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}



export const actionGetListUSerInvest = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/invest/get-list-invest`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListUserClient(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListUserCoinLockSub = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-list-coin-sub-lock`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: LIMIT_PAGE
            }
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const getChartUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/statistic/get-chart-user`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const validateAccount = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/user/validate-account`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.errorCode)
        }

        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}
export const getChartTransaction = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/statistic/get-chart-withdraw-deposit`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const getChartCommission = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/statistic/get-chart-commission`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const getChartDAU = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/statistic/logdau`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const getChartAssets = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/statistic/assets`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetDetailCommission = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload
        payload.size = limit || 20;

        let response = await fetchApi(`/admin/user/get-history-change-coin-commission-by-user`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.count || 0,
                count: Math.ceil((response?.data?.count) / limit),
                limit
            }
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetDetailChangeCoin = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-list-history-change-coin`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: 10
            }
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}



export const actionGetListUserClientMoney = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-list-user-money`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListUserClient(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetListUserCoinLockClient = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-list-user-coin-lock`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListUserClient(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const getTopRunner = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user_running/cms/top-runner?top=10`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
       /*  response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        } */
        await dispatch(actionSaveListUserRunner(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const getEvent = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/event`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveEvent(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const getUrBox = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/urbox/cms/redeemed`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveUrBox(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListUserCommission = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-list-user-coin-commission`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListUserCommission(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetAllCoin = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/setting/get-coin`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const getAllCoin = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/rewards/get-reward`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
   
}


export const getAllUser = (payload) => async (dispatch, getState) => {
    try {
        let response = await fetchApi(`/admin/user/get-all`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        return response.data

    } catch (error) {

    }
}
export const getAllUsers = (payload) => async (dispatch, getState) => {
    try {
        let response = await fetchApi(`/admin/user/get-alls`, "get", payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        return response.data

    } catch (error) {

    }
}

export const actionSaveListUserClient = (payload) => ({
    type: Types.SAVE_LIST_USER_CLIENT,
    payload,
})

export const actionSaveListUserClientCMS = (payload) => ({
    type: Types.SAVE_LIST_USER_CLIENT_CMS,
    payload,
})
export const actionSaveListHistoryPnl = (payload) => ({
    type: Types.SAVE_LIST_HISTORY_PNL,
    payload,
})

export const actionSaveListUserCommission = (payload) => ({
    type: Types.SAVE_LIST_USER_COMMISSION,
    payload,
})
export const actionSaveListUserRunner = (payload) => ({
    type: Types.TOP_RUNNER,
    payload,
})

export const actionSaveUrBox = (payload) => ({
    type: Types.UR_BOX,
    payload,
})

export const actionSaveEvent = (payload) => ({
    type: Types.EVENT,
    payload,
})

export const actionGetUserClientById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/get-user-info`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionSaveUserClientById(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveUserClientById = (payload) => ({
    type: Types.SAVE_USER_CLIENT_BY_ID,
    payload,
})

export const actionUpdateStatusUserClient = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/update-user`, "put", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        const state = getState()
        let newDataUserClientById = { ...state?.userClientReducer?.dataUserClientById }

        newDataUserClientById.data.status = payload?.status
        dispatch(actionGetUserClientById(payload))
        dispatch(actionSaveUserClientById(newDataUserClientById))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionCreateEvent = (payload, action) => async (dispatch) => {
    try {
        const url = payload?.id ? `/admin/event/${payload?.id}` : `/admin/event`;
        dispatch(actionLoading(true))
        let response = await fetchApi(url, action, payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const updateUser = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/update-user`, "put", dataPush)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListUserClientCMS(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const createUserCMS = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/create-user`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        // const state = getState()
        // const dataUserClientCMS = state?.userClientReducer?.dataUserClientCMS

        // let newData = { ...dataUserClientCMS }
        // const index = newData.rows.findIndex(it => it.id === dataPush.id)

        // console.log("filterModalllllllllllll", filterModal);

        // newData.rows[index] = response.data
        await dispatch(actionGetListUserClientCMS(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}



export const actionGetHistoryChangeCoinById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        payload.limit = limit || LIMIT_PAGE
        let response = await fetchApi(`/admin/user/history-change-coin`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || response?.data?.count || 0,
                count: Math.ceil((response?.data?.total || response?.data?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveHistoryChangeCoinById(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveHistoryChangeCoinById = (payload) => ({
    type: Types.SAVE_HISTORY_CHANGE_COIN_BY_ID,
    payload,
})

//thong ke user client
export const actionGetStatisticUser = (payload) => async (dispatch) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/dashboard/get-statistic-user`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionSaveStatisticUser(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveStatisticUser = (payload) => ({
    type: Types.SAVE_STATISTIC_USER,
    payload,
})
/////////////////////////////End User Client////////////////////////////////////////////////


/////////////////////////////List referral////////////////////////////////////////////////
export const actionGetListReferral = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-rank-refferal`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.count || 0,
                count: Math.ceil((response?.data?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListReferral(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionSaveListReferral = (payload) => ({
    type: Types.SAVE_LIST_REFERRAL,
    payload,
})
export const actionGetListPnl = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-list-pnl`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.count || 0,
                count: Math.ceil((response?.data?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListPnl(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionSaveListPnl = (payload) => ({
    type: Types.SAVE_LIST_PNL,
    payload,
})

export const actionGetListMilestoneReferral = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-rank-milestone`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.count || 0,
                count: Math.ceil((response?.data?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListMilestoneReferral(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveListMilestoneReferral = (payload) => ({
    type: Types.SAVE_LIST_MILESTONE_REFERRAL,
    payload,
})


export const actionGetUserReferralById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-user-ref`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.count || 0,
                count: Math.ceil((response?.data?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveUserReferralById(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListInvestByUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/invest/get-list-invest-by-user`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.count || 0,
                count: Math.ceil((response?.data?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveInvestByUser(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveUserReferralById = (payload) => ({
    type: Types.SAVE_USER_REFERRAL_BY_ID,
    payload,
})
export const actionSaveInvestByUser = (payload) => ({
    type: Types.SAVE_INVEST_BY_USER,
    payload,
})
export const actionGetUserMilestoneReferralById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-user-milestone`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.rows?.count || 0,
                count: Math.ceil((response?.data?.rows?.count) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveUserMilestoneReferralById(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveUserMilestoneReferralById = (payload) => ({
    type: Types.SAVE_USER_MILESTONE_REFERRAL_BY_ID,
    payload,
})

/////////////////////////////End List referral////////////////////////////////////////////////

/////////////////////////////Start User KYC////////////////////////////////////////////////
export const actionGetListKYC = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { filterModal, page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/kyc/get-list-kyc`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListKYC(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetUserKYC = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/kyc/get-user-kyc`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveUserKYC(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionUpdateUserKYC = (payload) => async (dispatch, getState) => {
        // const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/kyc/update-kyc`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionSaveUserKYC(response.data))
        dispatch(actionLoading(false))
        return response.data

        // let response = await fetchApi(`/admin/kyc/update-kyc`, "post", dataPush)

        // if (response.code !== 200) {
        //     dispatch(actionLoading(false))
        //     return checkErrorCode(response?.code, response?.message)
        // }

        //thêm
        // if (!payload.id) {
        //     await dispatch(actionGetUserKYC({ ...filterModal, user_id: dataPush.user_id }))
        // }else {
        //     const state = getState()
        //     const dataUserKYC = state?.userClientReducer?.dataUserKYC
        //     let newData = { ...dataUserKYC }

        //     const index = newData.rows.findIndex(it => it.id === payload.id)
        //     newData.rows[index] = response.data
        //     await dispatch(actionGetUserKYC(payload))
        // }
        // dispatch(actionLoading(false))
        // return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveListKYC = (payload) => ({
    type: Types.SAVE_LIST_USER_KYC,
    payload,
})

export const actionSaveUserKYC = (payload) => ({
    type: Types.SAVE_USER_KYC,
    payload,
})
/////////////////////////////End User KYC////////////////////////////////////////////////

export const actionAddGoldUserNotLoad = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/add-gold-user`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}

export const actionAddGoldUser = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal, coin_id } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/add-gold-user`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListUserClient({ ...filterModal, coin_id }))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}


export const actionAddMoneyUser = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/add-money-user`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListUserClientMoney(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}
export const actionAddMoneyUserNotDispatch = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/add-money-user`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}

export const actionLockGoldUser = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/lock-gold-user`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListUserCoinLockClient(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}
export const actionUnLockGoldUser = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/add-gold-user`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListUserClient(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}

export const actionChangeAmountMaster = (payload) => async (dispatch, getState) => {
    try {
        const { filterModal } = payload
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/master/change-amount`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionGetListUserClient(filterModal))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
        dispatch(actionLoading(false))
    }
}

export const actionGetListUserMaster = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/master/get-list`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListUserMaster(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionSaveListUserMaster = (payload) => ({
    type: Types.SAVE_LIST_MASTER,
    payload,
})


export const actionGetDataHistory = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/master/history`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveHistoryUserMaster(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveHistoryUserMaster = (payload) => ({
    type: Types.SAVE_HISTORY_MASTER,
    payload,
})

export const actionGetDetailMaster = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/master/detail`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}



export const actionSaveListConfigMilestone = (payload) => ({
    type: Types.SAVE_LIST_CONFIG_MILESTONE,
    payload,
})

export const actionGetListConfigMilestone = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/milestone/list`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionSaveListConfigMilestone(response.data))
        dispatch(actionLoading(false))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionUpdateConfigMilestone = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/milestone/update`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        //thêm
        await dispatch(actionGetListConfigMilestone({ ...filterModal }))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetDataHistoryChangeCoin = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-list-history-change-coin`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveHistoryChangeCoin(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionSaveHistoryChangeCoin = (payload) => ({
    type: Types.SAVE_HISTORY_CHANGE_COIN,
    payload,
})

export const actionGetListSuccessUpgradeUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/upgrade/get-list-success-upgrade`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListRequestUpgradeUser(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionGetListRequestUpgradeUser = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/upgrade/get-list-user-request-upgrade`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListRequestUpgradeUser(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionUpdateRequestUpgradeUser = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/upgrade/accept-request-upgrade-user`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        await dispatch(actionGetListRequestUpgradeUser(filterModal))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionDeleteRequestUpgrade = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const response = await fetchApi(`/admin/upgrade/delete-request-upgrade`, "post", payload);
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        dispatch(actionGetListRequestUpgradeUser({ page: 1 }))
        return response
    } catch (error) {
        dispatch(actionLoading(false))
        alert(error || error?.message)
    }
}

export const actionSubmitCommissionCMS = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/commission_cms/create`, "post", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        // const state = getState()
        // let newDataUserClientById = { ...state?.userClientReducer?.dataUserClientById }

        // newDataUserClientById.data.status = payload?.status
        // dispatch(actionSaveUserClientById(newDataUserClientById))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListCommissionCMS = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/commission_cms/get-list`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        // await dispatch(actionSaveListRequestUpgradeUser(response.data))



        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionDetailCommissionCMS = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/commission_cms/get-detail`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionSaveListRequestUpgradeUser = (payload) => ({
    type: Types.SAVE_LIST_REQUEST_UPGRADE_USER,
    payload,
})
export const actionGetListLockWithdrawByNewLogin = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/get-list-lock-withdraw`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListLockWithdrawByLogin(response.data))



        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}
export const actionSaveListLockWithdrawByLogin = (payload) => ({
    type: Types.SAVE_LIST_LOCK_WITHDRAW_BY_LOGIN,
    payload,
})

export const actionAcceptUnlockWithdraw = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/accept-unlock-withdraw`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        await dispatch(actionGetListLockWithdrawByNewLogin(filterModal))
        return response
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetDetailLockWithdraw = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload

        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/user/detail-lock-login`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        // await dispatch(actionSaveListLockWithdrawByLogin(response.data))



        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}